import React, { useEffect, useState, useMemo } from 'react';
import DatePicker from "react-datepicker";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Select from 'react-select'
import Application from '../../services/application.service';
import Helper from '../../helper';
import Auth from '../../services/auth.service';
import $ from 'jquery';
import editImg from '../../../assets/images/edit.svg';


const PersonalOne = (props) => {
    let input = props.input

    const [phone, setPhone] = useState('');
    const [oldEmail, setOldEmail] = useState('');
    const [emailToken, setEmailToken] = useState('');
    const [emailOtp, setEmailOtp] = useState('');
    const [isEview, setIsEview] = useState(0);

    const [nationality, setNationality] = useState(null);
    const [countryRes, setCountryRes] = useState(null);
    const [idType, setIdType] = useState(null);
    const [salutation, setSalutation] = useState('Mr');
    const [gender, setGender] = useState(null);
    const [matrialStatus, setMatrialStatus] = useState(null);
    const [isAPIload, setIsAPIload] = useState(false);
    const [dob, setDob] = useState(input.dob);

    useEffect(() => {
        if (input.nationality) setNationality(Helper.findCountryByLabel(input.nationality));
        if (input.id_type) { setIdType(Helper.findByValue(input.id_type, props.idTypeArr)); }
        if (input.salutation) setSalutation(Helper.findByValue(input.salutation, props.salutationArr));
        if (input.matrial_status) setMatrialStatus(Helper.findByValue(input.matrial_status, props.matrialArr));
        if (input.country_of_residence) setCountryRes(Helper.findCountryByLabel(input.country_of_residence));
        if (input.gender) setGender(Helper.findByValue(input.gender, props.genderArr));
        if (input.phone) setPhone(input.phone);
        if (input.email) setOldEmail(input.email)
    }, []);

    const handleSelectChange = (value, ele) => {
        if (ele.name == 'id_type') {
            setIdType(value);
        } else if (ele.name == 'salutation') {
            setSalutation(value);
        } else if (ele.name == 'gender') {
            setGender(value);
        } else if (ele.name == 'matrial_status') {
            setMatrialStatus(value);
        }
    }

    const handleFetchData = e => {
        if (isAPIload != false) return;
        if (input.isFetch != true) return;

        setIsAPIload(true)

        var formData = new FormData;
        formData.append('id_number', input.id_number);

        Application.fetchIdData(formData).then(res => {
            if (res.success === true) {
                var data = res.data;

                if (data && Object.keys(data).length > 0) {
                    for (const [key, value] of Object.entries(data)) {
                        if (input.hasOwnProperty(key) && value) input[key] = value;
                        if (key == 'matrial_status') setMatrialStatus(Helper.findByValue(value, props.matrialArr));
                        if (key == 'gender') setGender(Helper.findByValue(value, props.genderArr));
                        if (key == 'dob') setDob(value);
                        if (key == 'nationality') setNationality(Helper.findCountryByLabel(value));
                    }
                    props.setInput(input);
                }
            } else {
                Helper.validationError(res);
            }
            setIsAPIload(false)
        }).catch(err => console.log(err));
    }

    const handleSendOtp = (name, value) => {
        var formData = new FormData;
        formData.append(name, value ? value : '')
        formData.append('name', (input.first_name || input.last_name) ? `${input.first_name} ${input.last_name}` : '')
        formData.append('application_id', input.application_id)

        if (name == 'email') sendOtp(formData, setEmailToken, setIsEview);
    }

    const sendOtp = (formData, tokenVar, statusVar) => {
        $('.validationAlert').empty();
        $('.input-wrap').removeClass('error');

        Auth.appSendOtp(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                tokenVar(res.data.token)
                statusVar(1);
                Helper.success(res.message);
            } else {
                Helper.validationError(res);
            }
        }).catch(err => console.log(err));
    }

    const handleOtpVerify = (name, value, token, otp) => {
        if (!otp) return Helper.error('The OTP field is required.');
        var formData = new FormData;
        formData.append('token', token)
        formData.append('otp', otp ? otp : '')
        formData.append('application_id', input.application_id)
        formData.append(name, value)

        Auth.appOtpVerify(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                if (name == 'email') setIsEview(2);
                $('.validationAlert').empty();
                $('.input-wrap').removeClass('error');
                Helper.success(res.message);
            } else {
                Helper.validationError(res);
            }
        }).catch(err => console.log(err));
    }

    useEffect(() => {
        let c = (countryRes && countryRes.label) ? countryRes.label : '';
        props.setInput({ ...input, ...{ country_of_residence: c, country: c, postal_country: c } })
    }, [countryRes])

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isValidPhoneNumber(phone)) {
            input.nationality = (nationality && nationality.label) ? nationality.label : '';
            input.id_type = (idType && idType.value) ? idType.value : '';
            input.salutation = (salutation && salutation.value) ? salutation.value : '';
            input.gender = (gender && gender.value) ? gender.value : '';
            input.matrial_status = (matrialStatus && matrialStatus.value) ? matrialStatus.value : '';
            input.country_of_residence = (countryRes && countryRes.label) ? countryRes.label : '';

            var formData = Helper.convertFormData(input);
            formData.append('step', 'person1');
            formData.append('dob', dob);

            Application.applicationUpdate(formData).then(res => {
                if (res.success === true) {
                    props.setFormCount(2);
                }
            }).catch(err => console.log(err));
        }
    }
    // props.setStepNumber(1)
    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Personal Details</h2>
                    <div className="sub-step-indicator">Step 1/3</div>
                </div>
                <div className="form-fields">
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">ID Number<span className="asterisk">*</span></label>
                            <div className="two-input-wrap d-flex">
                                <Select className='readOnly' options={props.idTypeArr} name="id_type" value={idType} onChange={handleSelectChange} placeholder={'Select'}></Select>
                                <input type="text" name="id_number" className="form-control readOnly" placeholder="Enter Number" value={input.id_number} onChange={props.handleChange} />
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                    </div>
                    {idType && idType.value == 'I' &&
                        <div className="row form-check-alter">
                            <div className="col-12 form-check mb-5">
                                <div className="fetch-data">
                                    <input type="checkbox" name='isFetch' className="form-check-input" id="exampleCheck1" onChange={props.handleChecked} defaultChecked={input.isFetch} />
                                    <label className="form-check-label" htmlFor="exampleCheck1">I give my consent that Differential Capital can fetch my data.</label>
                                    <button className={isAPIload ? 'btn btn-primary btn-loading' : 'btn btn-primary'} disabled={input.isFetch ? false : true} type='button' onClick={handleFetchData}>Fetch Data</button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">First Name <span className="asterisk">*</span></label>
                            <div className="two-input-wrap d-flex">
                                <Select options={props.salutationArr} name="salutation" value={salutation} onChange={handleSelectChange} placeholder={'Select'}></Select>
                                <input type="text" className="form-control" name="first_name" placeholder='First Name' value={input.first_name} onChange={props.handleChange} />
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">Last name <span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <input type="text" className="form-control" name="last_name" placeholder='Last Name' value={input.last_name} onChange={props.handleChange} />
                            </div>

                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                                {isEview == 1 ?
                                    <>
                                        <label>Enter Your OTP</label>
                                        <div className="phone-edit-wrap">
                                            <span>{input.email}</span>
                                            <span className="edit-icon pl-2" onClick={e => setIsEview(0)}><img src={editImg} /></span>
                                        </div>
                                        <div className='input-wrap position-relative d-flex'>
                                            <input type="text" className="form-control" value={emailOtp} onChange={e => setEmailOtp(e.target.value)} />
                                            <div className="otp-send-btn">
                                                <a onClick={e => handleOtpVerify('email', input.email, emailToken, emailOtp)}>Verify</a>
                                            </div>
                                        </div>
                                        <div className="resend-send-btn"><a className="otp-send" onClick={e => handleSendOtp('email', input.email)}>Resend OTP</a></div>
                                    </> :
                                    <>
                                        <label htmlFor="name">Email Address<span className="asterisk">*</span></label>
                                        <div className="input-wrap position-relative d-flex">
                                            <input type="text" className={input.is_email_verified === 1 || isEview === 2 ? "form-control is-valid" : "form-control"} name="email" placeholder='Email' value={input.email} onChange={props.handleChange} readOnly={input.is_email_verified === 1 || isEview === 2} />
                                            <div className="otp-send-btn">
                                                {input.is_email_verified === 0 && isEview === 0 && <a className="otp-send" onClick={e => handleSendOtp('email', input.email)}>Send OTP</a>}
                                            </div>
                                        </div>
                                        <div className="validationAlert"></div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                                <label htmlFor="name">Telephone Number (Home/Work/Cell)<span className="asterisk">*</span></label>
                                <div className='input-wrap position-relative d-flex'>
                                    <div className="select-arrow"></div>
                                    <PhoneInput defaultCountry="ZA" placeholder="Enter phone number" name="phone" value={phone} onChange={setPhone} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">Gender<span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <Select options={props.genderArr} name="gender" value={gender} onChange={handleSelectChange} placeholder={'Select'}></Select>
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">Date of Birth<span className="asterisk">*</span></label>
                            <div className="input-wrap datepicker-wrap d-flex">
                                <DatePicker name="dob" selected={dob ? new Date(dob) : null} dateFormat="dd/MM/yyyy" peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" className="form-control" onChange={(date) => setDob(Helper.dateFormat(date, 'yyyy-MM-dd'))} autoComplete='off' />
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">Nationality<span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <Select options={props.countries} name="nationality" placeholder={'Select'} value={nationality} onChange={setNationality}></Select>
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label htmlFor="name">Marital Status <span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <Select options={props.matrialArr} name="matrial_status" value={matrialStatus} onChange={handleSelectChange} placeholder={'Select'}></Select>
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label>Country of Residence<span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <Select options={props.countries} name="country_of_residence" placeholder="Select Country" value={countryRes} onChange={setCountryRes} />
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group">
                            <label>Occupation<span className="asterisk">*</span></label>
                            <div className="input-wrap d-flex">
                                <input type="text" className="form-control" name="occupation" value={input.occupation || ''} onChange={props.handleChange} placeholder="Agriculture" />
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper ">
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PersonalOne;